import { createContext } from "react";

export const UserWorkspaceContext = createContext({
  workspaceLoading: true,
  setWorkspaceLoading: () => {},
  workspaces: [],
  setWorkspaces: () => {}
})